interface ITrackEvent {
  event: string
  eventName: string
  customDataObject: unknown
  dedupeId?: string
}

const sentDedupeIds = new Set<string>()

function hasAlreadySent(dedupeId: string) {
  try {
    if (sentDedupeIds.has(dedupeId)) {
      return true
    }
    if (window.sessionStorage?.getItem(`tracked_event:${dedupeId}`)) {
      return true
    }
  } catch {
    // sessionStorage pode estar indisponível (ex.: modo privado); segue sem cache persistente
  }
  return false
}

function markAsSent(dedupeId: string) {
  sentDedupeIds.add(dedupeId)
  try {
    window.sessionStorage?.setItem(`tracked_event:${dedupeId}`, '1')
  } catch {
    // sessionStorage pode estar indisponível (ex.: modo privado); tudo bem ignorar
  }
}

export function trackEvent({
  event,
  eventName,
  customDataObject,
  dedupeId,
}: ITrackEvent) {
  if (dedupeId) {
    const key = `${event}:${eventName}:${dedupeId}`
    if (hasAlreadySent(key)) {
      return
    }
    markAsSent(key)
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event,
    eventName,
    customDataObject,
  })
}
